import Util from '../../lib/utils';
import Vue from 'vue';
import {Store, Module, ActionContext} from 'vuex';
import Vuex from 'vuex';

Vue.use(Vuex);
import OrderMan from '../entities/orderman';

interface GiftCartState {
  giftGoodsList: any[];
  giftorderman: OrderMan;
}

class GifgCartModule implements Module<GiftCartState, any> {
  enshopid = Util.siss.auth.getenshopid();
  public state = {
    giftGoodsList: localStorage[this.enshopid + '_giftGoodsList'] ? JSON.parse(localStorage[this.enshopid + '_giftGoodsList']) : [],
    giftorderman: localStorage[this.enshopid + '_giftorderman'] ? JSON.parse(localStorage[this.enshopid + '_giftorderman']) : new OrderMan(),
    intergralmalGood: localStorage[this.enshopid + '_intergralmalGood'] ? JSON.parse(localStorage[this.enshopid + '_intergralmalGood']) : {},
  };
  public getters = {
    giftsum: (state) => {
      let total = 0;
      state.giftGoodsList.forEach((item) => {
        if (item.select) {
          total += item.giftcredit * item.number;
        }
      });
      return total;
    },
    giftgoddsNumber: (state) => {
      return state.giftGoodsList.length;
    },
    giftgoddsTotal: (state) => {
      let total = 0;
      state.giftGoodsList.forEach((item) => {
        if (item.select) {
          total += item.number;
        }
      });
      return total;
    },
  };
  public mutations = {
    // 多个积分礼品信息
    addGiftGoods: (state, data) => {
      state.giftGoodsList.push(data);
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftGoodsList', JSON.stringify(state.giftGoodsList));
    },
    // 单个积分礼品信息
    addGiftGood(state, data) {
      state.intergralmalGood = data
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_intergralmalGood', JSON.stringify(data));
    },
    deleteGiftGoods(state, index) {
      state.giftGoodsList.splice(index, 1);
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftGoodsList', JSON.stringify(state.giftGoodsList));
    },
    updateGiftGoods(state, data) {
      const {index, key, value} = data;
      state.giftGoodsList[index][key] = value;
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftGoodsList', JSON.stringify(state.giftGoodsList));
    },
    updategiftorderdealtype(state, data) {
      state.giftorderman.dealtype = data.dealtype;
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftorderman', JSON.stringify(state.giftorderman));
    },
    updatefiftordermemo(state, data) {
      state.giftorderman.usermemo = data.usermemo;
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftorderman', JSON.stringify(state.giftorderman));
    },
    updategiftorderuserinfo(state, data) {
      const {orderman, ordertel, addressall, id, longitude, latitude} = data;
      state.giftorderman.orderman = orderman;
      state.giftorderman.ordertel = ordertel;
      state.giftorderman.addressall = addressall;
      state.giftorderman.id = id;
      state.giftorderman.longitude = longitude;
      state.giftorderman.latitude = latitude;

      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftorderman', JSON.stringify(state.giftorderman));
    },
    deleteSelectedGiftGoods(state) {
      let tempGiftGoodsList = state.giftGoodsList;
      let unCheckedGiftGoodsList = [];
      tempGiftGoodsList.forEach((el, index) => {
        if (el.select == true) {
          //tempGiftGoodsList.splice(index, 1);
        } else {
          unCheckedGiftGoodsList.push(el);
        }
      });
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftGoodsList', JSON.stringify(unCheckedGiftGoodsList));
      state.giftGoodsList = unCheckedGiftGoodsList;
    },
    updateAllGiftGoods: (state, data) => {
      state.giftGoodsList = data;
      const enshopid = Util.siss.auth.getenshopid();
      localStorage.setItem(enshopid + '_giftGoodsList', JSON.stringify(state.giftGoodsList));
    },
  };
}

const giftCartModule = new GifgCartModule();
export default giftCartModule;
